import { message, Button, Modal, Select } from "antd";
import React, { useState } from "react";

const ShareWithTenants = ({ isModalVisible, handleCancel, handleOk }) => {
  const [tenant, setTenant] = useState("");
  const handleShare = () => {
    handleOk();
    message.success(
      `This inspection was successfully shared to the Tenant Portal.`
    );
  };

  const onChange = (value) => {
    setTenant(value || "");
  };

  const onSearch = (value) => {
    console.log("search:", value);
  };

  return (
    <div>
      <Modal
        title="Share Inspection with Tenants?"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleShare}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Button
                onClick={handleShare}
                type="primary"
                disabled={tenant === "" ? true : false}
              >
                Share
              </Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </div>
            <div></div>
          </div>
        }
      >
        <p>Select the occupancy you want to share the inspection with:</p>
        <Select
          showSearch
          allowClear
          placeholder="Select a Tenant"
          optionFilterProp="children"
          onChange={onChange}
          onSearch={onSearch}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={[
            {
              value: "Aamir Ali",
              label: "Aamir Ali",
            },
            {
              value: "Kashif Ali",
              label: "Kashif Ali",
            },
            {
              value: "Seerat Ali",
              label: "Seerat Ali",
            },
          ]}
          style={{ width: "100%", marginTop: "5px", marginBottom: "15px" }}
        />
        <p>
          The tenant(s) will have access to this inspection on their Online
          Portal and have the <b>option and ability</b> to sign it. They will
          also receive an email notification that it has been shared with them.
        </p>

        <br />

        <b>
          Once the inspection is shared, it will no longer be editable and you
          will have to revise it to make changes
        </b>
      </Modal>
    </div>
  );
};

export default ShareWithTenants;
